import React, { useRef, useEffect } from 'react';

const PreWithClickableLines = ({ 
  value, 
  onLineClick, 
  lineNumbersRef, 
  preRef, 
  onScroll, 
  lineNumbersRefClassName, 
  style = {},
  highlightedPath,
  resultPaths 
}) => {
  const lines = value ? value.split('\n') : [];
  return (
    <div
      ref={preRef}
      onScroll={onScroll}
      style={{
        width: '100%',
        height: '100%',
        minHeight: '120px',
        border: style.border || '1px solid #e0e4ea',
        borderRadius: style.borderRadius || '8px',
        boxShadow: style.boxShadow || '0 2px 12px 0 rgba(60,60,60,0.06)',
        background: style.background || 'linear-gradient(135deg, #f8fafc 0%, #e9f3fa 100%)',
        color: style.color || '#23272f',
        boxSizing: 'border-box',
        overflowY: 'auto',
        padding: '10px 0 10px 0',
      }}
      className="pre-clickable-lines"
    >
      {lines.map((line, idx) => {
        const isHighlighted = resultPaths && resultPaths[idx] === highlightedPath;
        return (
          <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
            <div
              className={lineNumbersRefClassName}
              style={{
                width: '40px',
                minWidth: '40px',
                maxWidth: '40px',
                textAlign: 'right',
                paddingRight: '10px',
                color: (idx + 1) % 5 === 0 ? '#24292e' : '#6e7681',
                fontWeight: (idx + 1) % 10 === 0 ? '600' : '400',
                fontFamily: '"Consolas", "Monaco", monospace',
                fontSize: '13px',
                userSelect: 'none',
                backgroundColor: '#f6f8fa',
                borderRight: '1px solid #e1e4e8',
                lineHeight: '1.5',
                height: '21px',
                boxSizing: 'border-box',
                paddingTop: 0,
                paddingBottom: 0,
                display: 'flex',
                alignItems: 'flex-start',
              }}
            >
              {idx + 1}
            </div>
            <div
              onClick={() => onLineClick(idx)}
              style={{
                flex: 1,
                userSelect: 'text',
                backgroundColor: isHighlighted ? '#b2f2b2' : 'transparent',
                padding: '2px 0 2px 8px',
                transition: 'background-color 0.2s ease',
                borderRadius: isHighlighted ? '4px' : '0',
                fontFamily: 'Consolas, Monaco, monospace',
                fontSize: 14,
                whiteSpace: 'pre',
                borderBottom: idx !== lines.length - 1 ? '1px solid #f0f2f6' : 'none',
                boxShadow: isHighlighted ? '0 1px 4px 0 rgba(60,180,60,0.07)' : 'none',
                position: 'relative',
                minHeight: '21px',
                display: 'block',
                ':hover': {
                  backgroundColor: isHighlighted ? '#7edc7e' : '#f0f0f0',
                }
              }}
            >
              <code style={{
                fontFamily: 'Consolas, Monaco, monospace',
                fontSize: 14,
                background: 'none',
                color: '#23272f',
                padding: 0,
                margin: 0,
                border: 'none',
                backgroundColor: 'transparent',
                display: 'block',
                whiteSpace: 'pre',
              }}>{line || '\u200B'}</code>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PreWithClickableLines; 